export class MasterData {
  ID: number;
  GroupName: string;
  Category: string;
  SortOrder: number;
  CreatedBy: string;
  CreatedDate: Date;
  UpdatedBy: string;
  UpdatedDate: Date;
}
